module.exports = function getResource(label, vars = []) {
    const resources = { onlyFewLeftCopy: 'Only a few left' };

    return resources[label];
};
